import {
  TAddEditHealthSystemRequest,
  THealthSystem
} from '../../HealthSystems/types'
import {
  API_DICTIONARY,
  HTTP_METHODS,
  VALIDATION_MESSAGES
} from '../../../constants'
import Fetcher from '../../../services/Fetcher'
import {
  TAddEditHealthSystemDataWithAddedDepartments,
  TAddEditHealthSystemDataWithStringDepartments
} from './HSDetails/types'

const fetcher = new Fetcher({})

export const addHealthSystem = async (uuid, data) =>
  fetcher.request<
    TAddEditHealthSystemRequest,
    TAddEditHealthSystemDataWithStringDepartments
  >({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}`,
    method: HTTP_METHODS.POST,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} added.`,
    data
  })

export const editHealthSystem = async (uuid, data, id) =>
  fetcher.request<TAddEditHealthSystemRequest, THealthSystem>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/${API_DICTIONARY.UPDATE}`,
    method: HTTP_METHODS.PUT,
    successMessage: `Health system ${VALIDATION_MESSAGES.SM0009} saved.`,
    data
  })

export const getHealthSystemData = async (uuid, id) =>
  fetcher.request<unknown, TAddEditHealthSystemDataWithAddedDepartments>({
    url: `${API_DICTIONARY.COMMUNITIES}${uuid}/${API_DICTIONARY.HEALTH_SYSTEMS}${id}/`,
    method: HTTP_METHODS.GET
  })
